module.exports = __webpack_public_path__ + "img/swiper_05.12b4fcc8.jpg";